import { createFileRoute } from '@tanstack/react-router'
import { clampNetworkDashboardSearch } from '~/components/routes/network-dashboard/page/network-dashboard-max-range'
import { NetworkDashboardPage } from '~/components/routes/network-dashboard/page/network-dashboard-page'
import { withRoutePermissions } from '~/utils/rbac'
import { networkDashboardSearchSchema } from './-search-schema'

function NetworkDashboardRoute() {
  // Une période de plus de 12 mois (URL enregistrée, clics éloignés) est ramenée au plafond de l'API.
  const search = clampNetworkDashboardSearch(Route.useSearch())
  const navigate = Route.useNavigate()

  return <NetworkDashboardPage search={search} navigate={navigate} />
}

export const Route = createFileRoute('/_authenticated/network-dashboard/')({
  component: NetworkDashboardRoute,
  staticData: { permission: ['read', 'network.network.network-dashboard'] },
  validateSearch: networkDashboardSearchSchema,
})

withRoutePermissions(Route)
